import React from "react";
import { __ } from "services/Translator";
import useConversations from "support/hooks/useConversations";

function formatDate(value) {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (isNaN(date.getTime())) {
    return "";
  }
  const today = new Date();
  const sameDay =
    date.getFullYear() === today.getFullYear() &&
    date.getMonth() === today.getMonth() &&
    date.getDate() === today.getDate();
  return sameDay
    ? date.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })
    : date.toLocaleDateString();
}

export default function ConversationListView({ active, onOpen }) {
  const { items, loading, error, hasMore, loadMore, reload } = useConversations(active);

  if (loading && !items.length) {
    return (
      <div className="supState" role="status">
        {__("Loading")}
      </div>
    );
  }

  if (error && !items.length) {
    return (
      <div className="supState supStateError" role="status">
        <p>{__("We could not load your conversations.")}</p>
        <button type="button" className="supBtn supBtnGhost" onClick={reload}>
          {__("Try again")}
        </button>
      </div>
    );
  }

  if (!items.length) {
    return <p className="supEmpty">{__("You have no conversations yet.")}</p>;
  }

  return (
    <>
      <ul className="supList">
        {items.map((item) => (
          <li key={item.reference}>
            <button type="button" className="supListItem" onClick={() => onOpen(item.reference)}>
              <span className="supListTop">
                <span className="supListSubject">{item.subject || __("Conversation")}</span>
                {item.unread_count > 0 && (
                  <span className="supListBadge">
                    <span className="visuallyHidden">{__("Unread messages")}</span>
                    {item.unread_count}
                  </span>
                )}
              </span>
              {item.last_message_excerpt && (
                <span className="supListExcerpt">{item.last_message_excerpt}</span>
              )}
              <span className="supListMeta">
                <span className={"supListStatus is-" + (item.status || "open")}>{item.status}</span>
                <span>{formatDate(item.last_activity_at)}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
      {hasMore && (
        <button type="button" className="supBtn supBtnGhost supLoadMore" onClick={loadMore} disabled={loading}>
          {loading ? __("Loading") : __("Show more")}
        </button>
      )}
    </>
  );
}
